import React, { createContext, useCallback, useContext, useState } from 'react';

const ToastContext = createContext(null);

const ICONS = { success: '✓', error: '✕', warning: '!', info: 'i' };

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback(id => {
    setToasts(list => list.filter(t => t.id !== id));
  }, []);

  const push = useCallback(
    (message, type = 'success', ttl = 4200) => {
      const id = Date.now() + Math.random();
      setToasts(list => [...list, { id, message, type }]);
      setTimeout(() => dismiss(id), ttl);
    },
    [dismiss],
  );

  const toast = {
    success: msg => push(msg, 'success'),
    error: msg => push(msg, 'error', 5600),
    warning: msg => push(msg, 'warning'),
    info: msg => push(msg, 'info'),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className="toast-stack">
        {toasts.map(t => (
          <div key={t.id} className={`toast ${t.type}`} onClick={() => dismiss(t.id)} role="status">
            <span className="t-ico">{ICONS[t.type]}</span>
            <span className="t-msg">{t.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
  return ctx;
};
